import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaBookOpen } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import './Blog.css';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch('https://api.ndtechland.com/api/HomeApi/Blogs');
        const data = await response.json();

        if (data.status === 200) {
          setBlogs(data.data);
        } else {
          console.error('Error fetching blogs:', data.message);
        }
      } catch (error) {
        console.error('Error fetching blogs:', error);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <>
      <Header />

      <section className="blog-section">
        <div className="container">
          <div className="blog-hero-header">
            <div className="blog-badge-pill">
              <FaBookOpen />
              <span>Insights & Articles</span>
            </div>
            <h1 className="blog-main-heading">
              Explore Our <span>Latest Blogs</span>
            </h1>
            <p className="blog-hero-desc">
              Discover cutting-edge tech insights, business strategies, and industry trends to help your organization grow and stay ahead.
            </p>
          </div>

          <div className="row g-4">
            {blogs.map(blog => (
              <div className="col-lg-4 col-md-6" key={blog.id}>
                <div className="blog-card">
                  <div className="blog-card-img-wrap">
                    <img
                      src={`https://api.ndtechland.com/image/${blog.blogImage}`}
                      className="blog-card-img"
                      alt={blog.title}
                    />
                    {blog.category && (
                      <span className="blog-category-tag">{blog.category}</span>
                    )}
                  </div>
                  <div className="blog-card-content">
                    <h5 className="blog-card-title">{blog.title}</h5>
                    <div className="blog-card-excerpt" dangerouslySetInnerHTML={{ __html: blog.content }} />
                    <Link to={`/Blogdetails/${blog.id}`} className="blog-read-btn">
                      <span>Read Article</span>
                      <FaArrowRight className="blog-read-btn-icon" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Blog;
